import angular from 'angular';
import ngRoute from 'angular-route';
import routes from './demo.routes';
import demo from './demo';

export default angular.module('app.components.demo', [
  ngRoute,
  demo,
])
  .config(routes)
  .name;

console.log('app.components.demo created');
